var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearchCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 19,
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1457 9.5L12.8571 12.2115L11.7113 13.3571L8.99985 10.6459L6.28874 13.3571L5.14286 12.2115L7.85397 9.5L5.14286 6.78849L6.28874 5.64286L8.99985 8.35407L11.7113 5.64286L12.8571 6.78849L10.1457 9.5ZM15.363 15.863C13.6054 17.6206 11.484 18.5 9 18.5C6.51536 18.5 4.39457 17.6206 2.63636 15.863C0.878786 14.1054 0 11.9846 0 9.5C0 7.01536 0.878786 4.89393 2.63636 3.13636C4.39457 1.37879 6.51536 0.5 9 0.5C11.484 0.5 13.6054 1.37879 15.363 3.13636C17.1212 4.89393 18 7.01536 18 9.5C18 11.9846 17.1212 14.1054 15.363 15.863Z",
  fill: "currentColor"
})));
export default SvgIconSearchCancel;